import { createNode } from '@glueapp/graph-types';

export const Trim = createNode({
    id: 'Trim',
    name: 'Trim',
    description: 'Removes all whitespace characters from the input text at the beginning and end',
    aiDescription:
        'Strips leading and trailing whitespace from a string. Connect a string to "Input"; outputs the trimmed string on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: { kind: 'string' },
    },
    outPorts: {
        Output: { kind: 'string' },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.trim() } };
    },
});
